import {
	Box,
	Button,
	Flex,
	Image,
	Spacer,
	Heading,
	Text,
	Badge,
	Tooltip,
} from '@chakra-ui/react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { FaEye } from "react-icons/fa";
import { MdChangeCircle, MdDeleteForever } from "react-icons/md";

import { useState } from 'react'

const AdminBusinessCard = ({ companyName, data, onDelete }) => {
	
	const [alertDialogIsOpen, setAlertDialogIsOpen] = useState(false)

	const setBadgeColorScheme = (status) => {
		let colorScheme

		if (status === 'approved') {
			colorScheme = 'green'
		} else if (status === 'pending') {
			colorScheme = 'yellow'
		} else {
			colorScheme = 'red'
		}

		return colorScheme
	}


	const openConfirmDialog = (status) => {
		
		setAlertDialogIsOpen(true)
	}

	return (
		<Box borderWidth={'1px'} borderColor={'gray.300'} p={2}>
			<Flex
				align="center"
				flexDirection={['column', 'column', 'row', 'row']}
				p={['3', '3', '0', '0']}
			>
				<Box mb={['2', '2', '0', '0']}>
					<Flex
						align="center"
						flexDirection={['column', 'column', 'row', 'row']}
						justify={['center', 'center', 'start', 'start']}
						textAlign={['center', 'center', 'start', 'start']}
					>
						<Image
							src={data?.logo}
							alt=""
							boxSize={'80px'}
							objectFit={'contain'}
							mr={['0', '0', '4', '4']}
							mb={['2', '2', '0', '0']}
						/>
						<Box>
							<Heading as="h3" fontSize="xl">
								{companyName}

								<Badge ms={2} colorScheme={setBadgeColorScheme(data?.status)}>
									{data?.status}
								</Badge>
								{data?.pending_changes && (
								<Badge ms={2} colorScheme={setBadgeColorScheme('warning')}>
									Pending Changes
								</Badge>
								)}
								
							</Heading>

							<Text>Created on: {moment(data?.created_at).format('LL')}</Text>
						</Box>
					</Flex>
				</Box>
				<Spacer />
				{/* <Flex direction="column" gap={2}> */}
								
				<Box>
				<Tooltip label="View details" hasArrow>
					<Button
					as={Link}
					to={`/admin/business-list/details/${data?.id}`}
					size="sm"
					bg="orange.400" // Orange for "View"
					color="white"
					_hover={{ bg: "orange.500" }}
					variant="solid"
					ml={["0", "0", "2", "0"]}
					>
					<FaEye />
					</Button>
				</Tooltip>
				</Box>

				<Box>
				<Tooltip label="Delete" hasArrow>
					<Button
					onClick={() => onDelete(data.id)}
					size="sm"
					bg="red.500" // Red for "Delete"
					color="white"
					_hover={{ bg: "red.600" }}
					variant="solid"
					ml={["1", "0", "2", "1"]}
					>
					<MdDeleteForever />
					</Button>
				</Tooltip>
				</Box>

				{data?.pending_changes && (
				<Box>
					<Tooltip label="Change request" hasArrow>
					<Button
						as={Link}
						to={`/admin/business-list/request-details/${data?.id}`}
						size="sm"
						bg="purple.500" // Purple for "Change Request"
						color="white"
						_hover={{ bg: "purple.600" }}
						variant="solid"
						ml={["1", "0", "2", "1"]}
					>
						<MdChangeCircle />
					</Button>
					</Tooltip>
				</Box>
				)}
				
				
				{/* </Flex> */}
			</Flex>
		</Box>
	)
}

export default AdminBusinessCard
